// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__B-Ynz","bigColWidth":"Table_bigColWidth__3EgPY","biggerColWidth":"Table_biggerColWidth__1nxkA","row":"Table_row__2tPPW","col":"Table_col__15XtO"};